import React from 'react';
import { Alert, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProductionStatusChip from '../shared/ProductionStatusChip';
import type { ProductionOrderRef } from '../../types/production.types';
import { formatQuantity } from '../../utils/productionFormat';

interface ProductionChildOrdersPanelProps {
  rows: ProductionOrderRef[];
  outdated?: boolean;
  onOpen: (id: string) => void;
  onRegenerate?: () => void;
  regenerating?: boolean;
}

const ProductionChildOrdersPanel: React.FC<ProductionChildOrdersPanelProps> = ({
  rows,
  outdated,
  onOpen,
  onRegenerate,
  regenerating,
}) => {
  const { t } = useTranslation('production');

  return (
    <>
      {outdated ? (
        <Alert
          severity="warning"
          sx={{ mb: 1 }}
          action={(
            <Button color="inherit" size="small" disabled={regenerating} onClick={onRegenerate}>
              {t('editor.regenerate')}
            </Button>
          )}
        >
          {t('detail.outdated')}
        </Alert>
      ) : null}
      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('orders.columns.orderNumber')}</TableCell>
              <TableCell>{t('orders.columns.product')}</TableCell>
              <TableCell align="right">{t('orders.columns.planned')}</TableCell>
              <TableCell align="right">{t('orders.columns.produced')}</TableCell>
              <TableCell>{t('orders.columns.status')}</TableCell>
              <TableCell align="right">{t('detail.level')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover sx={{ cursor: 'pointer' }} onClick={() => onOpen(row.id)}>
                <TableCell>{row.orderNumber}</TableCell>
                <TableCell>{row.productName || '—'}</TableCell>
                <TableCell align="right">{formatQuantity(row.plannedQuantity, row.unit)}</TableCell>
                <TableCell align="right">{row.producedQuantity == null ? '—' : formatQuantity(row.producedQuantity, row.unit)}</TableCell>
                <TableCell><ProductionStatusChip status={row.status} /></TableCell>
                <TableCell align="right">{row.level}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ProductionChildOrdersPanel;
